import '../css/ProductTab.css';

import * as React from 'react';

import { ProductCategory, ISeedProduct } from '../../../../../infrastructure/interfaces';
import Logo from '../Logo';
import AccordionItem from '../common/AccordionItem';
import ProductItem from './ProductItem';
import { SeedCategoryAccordion } from './SeedCategoryAccordion';
import { groupBy } from 'lodash';

export interface IBrochureProductProps {
  productCategories: ProductCategory[];
  connectDragSource?: any;
  isDragging?: any;
  seedList: ISeedProduct[];
}

export interface IBrochureProductsState {
  openedCategories: number[];
  productsFilter: string;
}

export default class ProductTab extends React.Component<IBrochureProductProps, IBrochureProductsState> {
  shouldUpdate = false;
  oldProducts:ProductCategory[] = [];
  constructor(props: any) {
    super(props);

    this.state = {
      openedCategories: [],
      productsFilter: '', //search term
    };
    this.oldProducts = this.props.productCategories;
  }

  filterProducts = (productCategories: ProductCategory[]): ProductCategory[] => {
    const filteredCategories = [];
    const productsFilter = this.state.productsFilter.toUpperCase();

    for (let i = 0; i < productCategories.length; i += 1) {
      const c = productCategories[i];
      var filteredProducts = c.products.filter(p => productsFilter
        ? p.name.toUpperCase().indexOf(productsFilter) > -1
        : true);
      filteredProducts = filteredProducts.filter(p => p.published);
      if (filteredProducts.length) {
        filteredCategories.push({
          ...c,
          products: filteredProducts,
        });
      }
    }

    return filteredCategories;
  }

  onFilterChange = (e: any) => {
    this.setState({
      productsFilter: e.target.value,
    });
    e.keyCode === 8 && !e.target.value ? this.shouldUpdate = true : this.shouldUpdate = false;
  }

  render() {
    const { productCategories } = this.props;
    const filterProducts = this.filterProducts(productCategories);
    const filteredSeeds = this.props.seedList.filter(
      s => s.published && s.name.match(new RegExp(this.state.productsFilter, "ig")));
    const seedsByCategoryObj = groupBy(filteredSeeds, (e) => e.category.name)

    const seedsByCategory = Object.entries(seedsByCategoryObj)
      .map(k => { return { category: k[0], seeds: k[1] }
      })
      .sort((a, b) => a.category.localeCompare(b.category));
    return (
      <div className="sidePane">
        <div className="productTab">
          <div className="productTab-search">
            <input
              type="text"
              onKeyUp={this.onFilterChange}
              placeholder="Search Products"
            />
            <span className="productTab-search-ico"></span>
          </div>
          <ul className="product-list">
            {this.renderSeedHierarchy(seedsByCategory)}
            {this.renderLovelandProductHierarchy(filterProducts)}
          </ul>
        </div>
        <Logo />
      </div>
    );
  }
  renderSeedHierarchy(seedsByCategory: { category: string, seeds: ISeedProduct[]}[]) {
    return (
      <SeedCategoryAccordion 
        categories={seedsByCategory} 
        open={!!this.state.productsFilter}
        //key is because the child should be open if a search term is applied, closed if  it's empty
        //but then also internally manage its own state for clicking the carat. The key is 
        //to reset the internal state of <SeedCategoryAccordion> when the search term changes
        //https://reactjs.org/blog/2018/06/07/you-probably-dont-need-derived-state.html
        key={this.state.productsFilter} //so 
        />);

  }
  renderLovelandProductHierarchy(filterProducts:ProductCategory[]) {
    return filterProducts.map((c) => (
     <AccordionItem
       key={c.id}
       title={c.name}
       open={!!this.state.productsFilter}
       shouldUpdate={true}
     >
       {c.products.map(p => (
         <ProductItem
           product={p}
           type={'item'}
           key={p.id} 
           className="product-list-item"
         />))
       }
     </AccordionItem>))
  }
}






// WEBPACK FOOTER //
// ./src/components/Editor/components/SidePanel/ProductTab/ProductTab.tsx